let aDriver = {};
let aVehicle = {};
let pageAction = '';
let driverType = '';
let replacedFixedId = '';

export default {
    setDriver(driver) {
        aDriver = driver;
    },

    getDriver() {
        return aDriver;
    },

    setVehicle(vehicle) {
        aVehicle = vehicle;
    },

    getVehicle() {
        return aVehicle;
    },

    getPageAction() {
        return pageAction;
    },

    setPageAction(action) {
        pageAction = action;
    },

    getDriverType() {
        return driverType;
    },

    setDriverType(type) {
        driverType = type;
    },

    getReplacedFixedId() {
        return replacedFixedId;
    },

    setReplacedFixedId(fixedId) {
        replacedFixedId = fixedId;
    }
};
